<template>
  <GenericProgressLinear
    :icon="'mdi-floor-plan'"
    :title="'Secrets'"
    :stats="stats"
  ></GenericProgressLinear>
</template>

<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "SecretsProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/secrets",["stats"])
  },
};
</script>
